import React from 'react';
import { TwitterPicker } from 'react-color';

/**
 * Twitter-style Color Picker UI Component
 * 
 * Props:
 * - color (optional): The color value (string) to show as selected.
 * - onChange (function): Called with {hex, rgb, ...} on color change.
 * - colors (optional): Array of colors to display (default Twitter palette).
 * - triangle (optional): 'hide', 'top-left', or 'top-right' (default is 'top-left').
 * - ...props: Any additional props are spread to TwitterPicker
 *
 * Usage:
 * <ColorPickerTwitter color="#36c" onChange={handleColorChange} />
 */
const ColorPickerTwitter = ({ color, onChange, colors, triangle, ...props }) => {
  return (
    <TwitterPicker
      color={color}
      onChange={onChange}
      colors={colors}
      triangle={triangle}
      {...props}
    />
  );
};

export default ColorPickerTwitter;
